import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken  } from "../Global";
import {MaterialReactTable} from 'material-react-table';
import Swal from 'sweetalert2';
import { format } from 'date-fns';
import  "./../assets/css/custom.css"; 
import PropTypes from 'prop-types';
import {
  Box,
} from '@mui/material';

const EmployeeSetting = () => {
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  const [permission, setPermission] = useState({});


  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const defaultDate = (formatDate(new Date()));



  useEffect(() => {
        setPermission(FindModuleById(442)); 
        console.log(permission);
      axios.post("/employee-setting/listing",{},{  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
      .then((response) => {
        if (response.data.code === 200) {
         setData(response.data.data.settings);
        }
        else  if (response.data.code === 401) {
          window.location.href = "/login";
        }else{
          window.location.href = "/login"; 
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);



  const toggleMobileMenu = () => {
    setMenu(!menu);
  };


const ActionCell = ({ row }) => {
  return (
    <div style={{ textAlign: 'center' }}>
      <button
        className="btn btn-primary btn-block"
        id={`button-all-${row.original.id}`}
        onClick={() => editSetting(row.original)}
      >
        EDIT
      </button>
    </div>
  );
};

// ✅ Define PropTypes for `row` to fix ESLint warnings
ActionCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    }).isRequired,
  }).isRequired,
};

const columns = [
  {
    accessorKey: 'gross_hourly_wage',
    header: 'Gross Hourly Wage',
  },{
    accessorKey: 'net_hourly_wage',
    header: 'Net Hourly Wage',
  },
  {
    accessorKey: 'plafound_cnss',
    header: 'Plafound CNSS',
  },
  {
    accessorKey: 'cnss_rate',
    header: 'CNSS Rate',
  },
  {
    accessorKey: 'amo_rate',
    header: 'AMO Rate',
  },
  {
    accessorKey: 'application_date',
    header: 'Application Date',
  },
  // {
  //   accessorKey: 'status',
  //   header: 'Status',
  // },
  {
    header: 'Created At',
    accessorFn: (row) => `${format(new Date(row.created_at), 'PPP')} `,
  },
  {
    header: 'Created By',
    accessorFn: (row) =>
      row.createdby ? `${row.createdby.first_name} ${row.createdby.last_name}` : '',
  },
  {
    header: 'Updated At',
    accessorFn: (row) => `${format(new Date(row.updated_at), 'PPP')} `,
  },
  {
    header: 'Updated By',
    accessorFn: (row) =>
      row.updatedby ? `${row.updatedby.first_name} ${row.updatedby.last_name}` : '',
  },
  {
    header: 'ACTION',
    Cell: ActionCell, // ✅ Use the separate ActionCell component
  },
];


const editSetting = async (row) => {
  console.log(row);
  const { value: formValues } = await Swal.fire({
    title: 'Setting',
   // html:'<div style="display: grid;"><input type="hidden" value="'+row.id+'" id="setting_id" class="swal2-input" placeholder="Enter Gross Hourly Wage"><label style="text-align: left; padding-left: 6px;margin-bottom:3px;"> Gross Hourly Wage</label><input type="number" id="edit_gross_hourly_wage" value="'+row.gross_hourly_wage+'"  class="swal2-input" placeholder="Enter Gross Hourly Wage"><input type="number" id="edit_cnss_rate" class="swal2-input" value="'+row.cnss_rate+'"  placeholder="CNSS"><input type="number"  value="'+row.amo_rate+'" id="edit_amo_rate" class="swal2-input" placeholder="AMO Rate"><input type="date"  value="'+row.application_date+'" id="edit_application_date" class="swal2-input" placeholder="Application Date"></div>',
   html:'<div style="display: grid;">   <input type="hidden" value="'+row.id+'" id="setting_id" class="swal2-input" placeholder="Enter "><label style="text-align: left; padding-left: 6px;margin-bottom:3px;"> Net Hourly Wage</label> <input type="number" id="edit_net_hourly_wage" value="'+row.net_hourly_wage+'"  class="swal2-input" placeholder="Enter Net Hourly Wage"><label style="text-align: left; padding-left: 6px;margin-bottom:3px;"> Gross Hourly Wage</label> <input type="number" id="edit_gross_hourly_wage" value="'+row.gross_hourly_wage+'"  class="swal2-input" placeholder="Enter Gross Hourly Wage"><label style="text-align: left; padding-left: 6px;margin-bottom:3px;"> Plafound CNSS</label> <input type="number" id="edit_plafound_cnss" class="swal2-input" value="'+row.plafound_cnss+'"  placeholder="Plafound CNSS"> <label style="text-align: left; padding-left: 6px;margin-bottom:3px;"> CNSS</label> <input type="number" id="edit_cnss_rate" class="swal2-input" value="'+row.cnss_rate+'"  placeholder="CNSS">  <label style="text-align: left; padding-left: 6px;margin-bottom:3px;"> AMO Rate</label><input type="number"  value="'+row.amo_rate+'" id="edit_amo_rate" class="swal2-input" placeholder="AMO Rate"> <label style="text-align: left; padding-left: 6px;margin-bottom:3px;"> Application Date</label>   <input type="date"  value="'+row.application_date+'" id="edit_application_date" class="swal2-input" placeholder="Select">   </div>', 
   showCancelButton: true,
    confirmButtonText: 'Update',
    cancelButtonText: 'Cancel',
    customClass: "swal-orders",
    preConfirm: () => {
      const setting_id = document.getElementById('setting_id').value;
      const net_hourly_wage = document.getElementById('edit_net_hourly_wage').value;
      const plafound_cnss = document.getElementById('edit_plafound_cnss').value;
      const gross_hourly_wage = document.getElementById('edit_gross_hourly_wage').value;
      const cnss_rate = document.getElementById('edit_cnss_rate').value;
      const amo_rate = document.getElementById('edit_amo_rate').value;
      const application_date = document.getElementById('edit_application_date').value;
      
      
      if (!setting_id) {
        Swal.showValidationMessage('setting_id is required');
        return null;
      }
      if (!plafound_cnss) {
        Swal.showValidationMessage('Plafound CNSS Wage is required');
        return null;
      }
      if (!net_hourly_wage) {
        Swal.showValidationMessage('Net Hourly Wage is required');
        return null;
      }
      if (!gross_hourly_wage) {
        Swal.showValidationMessage('Gross Hourly Wage is required');
        return null;
      }
      if (!cnss_rate) {
        Swal.showValidationMessage('CNSS Rate is required');
        return null;
      }
      if (!amo_rate) {
        Swal.showValidationMessage('AMO Rate is required');
        return null;
      }
      if (!application_date) {
        Swal.showValidationMessage('Application Date is required');
        return null;
      }
      return { setting_id,net_hourly_wage,plafound_cnss, gross_hourly_wage, cnss_rate, amo_rate,application_date };
    }
  });

  if (formValues) {
    try {
      const response = await axios.post(`/employee-setting-update-single`, {
        setting_id: formValues.setting_id,
        plafound_cnss: formValues.plafound_cnss,
        net_hourly_wage: formValues.net_hourly_wage,
        gross_hourly_wage: formValues.gross_hourly_wage,
        cnss_rate: formValues.cnss_rate,
        amo_rate: formValues.amo_rate,
        application_date: formValues.application_date
      }, {
        headers: {
          Authorization: `Bearer ${Authtoken}`,
          Apitoken: Apitoken
        },
      });


      if (response.data.code === 200) {
        Swal.fire(
          'Success!',
          'Setting Updated Successfully.',
          'success'
        );
        axios.post("/employee-setting/listing",{},{  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
        .then((response) => {
         
          if (response.data.code === 200) {
           setData(response.data.data.settings);
          }
          else  if (response.data.code === 401) {
            window.location.href = "/login";
          }else{
            window.location.href = "/login"; 
          }
        })
        .catch((error) => {
          console.log(error);
        });
      }
    } catch (error) {
      Swal.fire(
        'Error!',
        'There was a problem Setting.',
        'error'
      );
    }
  }

}

  
  const updateEmployeeSetting = async (id) => {
    const { value: formValues } = await Swal.fire({
      title: 'Setting',
     html: '<div style="display: grid;"> <label style="text-align: left; padding-left: 6px;margin-bottom:3px;"> Net Hourly Wage</label> <input type="number" id="net_hourly_wage" class="swal2-input" placeholder="Enter Net Hourly Wage"> <label style="text-align: left; padding-left: 6px;margin-bottom:3px;"> Gross Hourly Wage</label> <input type="number" id="gross_hourly_wage" class="swal2-input" placeholder="Enter Gross Hourly Wage">  <label style="text-align: left; padding-left: 6px;margin-bottom:3px;">Plafound CNSS</label> <input type="number" id="plafound_cnss" class="swal2-input" placeholder="Plafound CNSS">  <label style="text-align: left; padding-left: 6px;margin-bottom:3px;"> CNSS</label> <input type="number" id="cnss_rate" class="swal2-input" value="0" placeholder="CNSS">     <label style="text-align: left; padding-left: 6px;margin-bottom:3px;"> AMO Rate</label>     <input type="number"  value="0" id="amo_rate" class="swal2-input" placeholder="AMO Rate">  <label style="text-align: left; padding-left: 6px;margin-bottom:3px;"> Application Date</label>      <input type="date"  id="application_date" class="swal2-input"  value="'+defaultDate+'" placeholder="Select "> </div>',
  
     showCancelButton: true,
      confirmButtonText: 'Update',
      cancelButtonText: 'Cancel',
      customClass: "swal-orders",
      preConfirm: () => {
        const net_hourly_wage = document.getElementById('net_hourly_wage').value;
        const gross_hourly_wage = document.getElementById('gross_hourly_wage').value;
        const plafound_cnss = document.getElementById('plafound_cnss').value;
        const cnss_rate = document.getElementById('cnss_rate').value;
        const amo_rate = document.getElementById('amo_rate').value;
        const application_date = document.getElementById('application_date').value;
        
        
        if (!net_hourly_wage) {
          Swal.showValidationMessage('Net hourly Wage is required');
          return null;
        }
        if (!gross_hourly_wage) {
          Swal.showValidationMessage('Gross Hourly Wage is required');
          return null;
        }
        if (!plafound_cnss) {
          Swal.showValidationMessage('Playfound CNSS is required');
          return null;
        }
        if (!cnss_rate) {
          Swal.showValidationMessage('CNSS Rate is required');
          return null;
        }
        if (!amo_rate) {
          Swal.showValidationMessage('AMO Rate is required');
          return null;
        }
        
        if (!application_date) {
          Swal.showValidationMessage('Application Date is required');
          return null;
        }
        return { id,net_hourly_wage,plafound_cnss, gross_hourly_wage, cnss_rate, amo_rate, application_date };
      }
    });

    if (formValues) {
      try {
        const response = await axios.post(`/employee-setting-update`, {
          employee_id: formValues.id,
          plafound_cnss: formValues.plafound_cnss,
          net_hourly_wage: formValues.net_hourly_wage,
          gross_hourly_wage: formValues.gross_hourly_wage,
          cnss_rate: formValues.cnss_rate,
          amo_rate: formValues.amo_rate,
          application_date: formValues.application_date
        }, {
          headers: {
            Authorization: `Bearer ${Authtoken}`,
            Apitoken: Apitoken
          },
        });

  
        if (response.data.code === 200) {
          Swal.fire(
            'Success!',
            'Setting Updated Successfully.',
            'success'
          );
          axios.post("/employee-setting/listing",{},{  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
          .then((response) => {
           
            if (response.data.code === 200) {
             setData(response.data.data.settings);
            }
            else  if (response.data.code === 401) {
              window.location.href = "/login";
            }else{
              window.location.href = "/login"; 
            }
          })
          .catch((error) => {
            console.log(error);
          });
        }
      } catch (error) {
        Swal.fire(
          'Error!',
          'There was a problem Setting.',
          'error'
        );
      }
    }
  };

  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Setting</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item active">Setting</li>
                </ul>
              </div>
              <div className="col-auto">
                {/* <Link to="/employee-setting-add" className="btn btn-primary me-1">
                  <i className="fas fa-plus"></i>
                </Link> */}
                {permission && permission.add == 1 && (
                   
                   <button onClick={() => updateEmployeeSetting(5345)} className="btn btn-primary"  >
                      <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '1rem',
                          }}
                        >
                          
                    <span>Update Setting </span>
                  </Box>
            </button>
                )}

                
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              {permission && permission.list == 1 && (
                <div className="card card-table">
                  <div className="card-body">
                    <div className="table-responsive">
                    <MaterialReactTable columns={columns} data={data} 
                      // enableColumnFilterModes
                      enableColumnOrdering
                      // enableGrouping
                      enablePinning
                    // enableRowActions
                      // enableRowSelection
                      // initialState={{ showColumnFilters: true }}
                    
                      // renderRowActionMenuItems={({ row }) => [
                      //   <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                      //     Edit
                      //   </MenuItem>,
                      
                      // ]}
                    />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default EmployeeSetting;
